// extracted by mini-css-extract-plugin
export default {"auth_layout_container":"AuthLayout_auth_layout_container__rewRv","main_container":"AuthLayout_main_container__YMjFa"};